import {
  Button,
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Modal shown when user is currently in active trial and wants to provision
 * Warns that trial will be stopped and solutions will transfer to paid
 */
const TrialActiveConfirmModal = ({ isOpen, onCancel, onConfirm }: Props) => {
  const { t } = useTranslation('welcome');
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  return (
    <Modal
      isOpen={isOpen}
      size="xl"
      onClose={onCancel}
      closeOnEsc
      closeOnOutsideClick
    >
      <ModalOverlay />
      <ModalContent width="672px" minHeight="320px">
        <ModalHeader p="16px 48px 12px 24px" borderBottom="none">
          <Text fontSize="20px" lineHeight="28px" fontWeight="400">
            {t('welcome.trialActiveConfirmModal.title')}
          </Text>
        </ModalHeader>
        <ModalBody p="12px 24px 28px 24px">
          <Text
            color={colorStyle.color.primary}
            mb="16px"
            fontSize="14px"
            lineHeight="20px"
          >
            <Trans i18nKey="welcome.trialActiveConfirmModal.desc1">
              placeholder
              <strong>placeholder</strong>
              placeholder
            </Trans>
          </Text>
          <Text
            color={colorStyle.color.primary}
            mb="16px"
            fontSize="14px"
            lineHeight="20px"
          >
            <Trans i18nKey="welcome.trialActiveConfirmModal.desc2">
              placeholder
              <Link
                href="https://docs.trendmicro.com/en-us/documentation/article/trend-vision-one-credit-requirements-v1ecs"
                target="_blank"
              >
                placeholder
              </Link>
              placeholder
            </Trans>
          </Text>
          <Text
            color={colorStyle.color.primary}
            fontSize="14px"
            lineHeight="20px"
          >
            {t('welcome.trialActiveConfirmModal.question')}
          </Text>
        </ModalBody>
        <ModalFooter p="16px 32px 32px" borderTop="none">
          <Flex width="100%" justifyContent="flex-end" gap="12px">
            <Button variant="primary" onClick={onConfirm}>
              {t('welcome.trialActiveConfirmModal.confirm')}
            </Button>
            <Button onClick={onCancel}>{t('common.button.cancel')}</Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TrialActiveConfirmModal;
